import React, { useState }  from 'react'


export const AddStaff= (props)=> {

    var [name,setName]=useState()
    const postURL = "https://mediumclocking.herokuapp.com/"  

    const nameUpdate=(event)=>{ // Dealing with name field changes to update our state
        setName(event.target.value)
    }

    const deleteFirstEntry=()=>{
        var id = props.allStaff[0]._id
        fetch(`${postURL}${id}`, {
            method: 'DELETE',
        })
        .then(res => res.text())
        .then(res => console.log(res)) 
    }

    const handleSubmit=(e)=> {

        document.getElementById("nameInput").value= '';
         //Our previously set up route in the backend
        e.preventDefault();
        setName('');
        if(Object.keys(props.allStaff).length>4){
            deleteFirstEntry();
        }

        // Once the form has been submitted, this function will post to the backend
        // var posting= JSON.stringify({ // We should keep the fields consistent for managing this data later
        //     name: name,
        //     clockedIn:false,
        //     dates:[]
        // })
        
        
        fetch(postURL, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ // We should keep the fields consistent for managing this data later
                name: name,
                clockedIn:false,
                dates:[]
            })

        })
        .then(()=>{
            // Once posted, the user will be notified 
            alert('You have been added to the system!');
            
        })
        
    }

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <label>Full Name:</label>
                <input id="nameInput" defaultValue={name} required onChange={nameUpdate}></input>
                <button type="submit"> Submit</button>
            </form>
        </div>
    )
    
}

export default AddStaff